"use client";

import Link from "next/link";
import { Icon } from "@/components/ui/icon";

import { Container } from "@/app/_components/layout/container";
import { Eyebrow } from "@/app/_components/sections/eyebrow";
import { HeroStickman } from "@/app/_components/sections/hero-stickman";
import { Button } from "@/components/ui/button";
import { hero } from "@/lib/content/homepage";
import { trackEvent } from "@/lib/analytics/dataLayer";

export function Hero() {
  return (
    <section
      aria-label="Hero"
      className="bg-background text-foreground flex min-h-[calc(100vh-80px-3px)] items-center pt-2 pb-6 md:py-16"
    >
      <Container>
        <div className="grid gap-2 lg:grid-cols-12 lg:items-center lg:gap-12">
          <HeroStickman className="max-w-[240px] lg:hidden" />

          <div className="min-w-0 lg:col-span-7">
            <Eyebrow>{hero.eyebrow}</Eyebrow>
            <h1 className="text-display-xl mt-6 text-clarus-dark">
              {hero.headlineLines.map((line, i) => (
                <span key={i} className="block">
                  {line}
                </span>
              ))}
            </h1>
            <p className="text-subline mt-6 max-w-xl text-clarus-dark/80">
              {hero.subline}
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-3 sm:mt-10">
              <Button
                asChild
                size="xl"
                variant="primary"
                className="[&_svg]:!size-6"
              >
                <Link
                  href={hero.cta.href}
                  onClick={() => trackEvent("cta_scan", { location: "hero" })}
                >
                  <span
                    aria-hidden="true"
                    className="flex h-12 w-12 items-center justify-center rounded-full bg-clarus-yellow text-clarus-dark"
                  >
                    <Icon name="arrow_forward" className="text-[24px]" />
                  </span>
                  {hero.cta.label}
                </Link>
              </Button>
            </div>
            {/*
              Trust marks stack on mobile, then flow into rows and wrap onto
              multiple lines as needed from `sm` upwards — never a horizontal
              scrollbar.
            */}
            <ul
              className="mt-8 flex flex-col gap-2 sm:mt-10 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-6 sm:gap-y-3"
              aria-label="Vertrauenswürdig"
            >
              {hero.trustMarks.map((mark) => (
                <li
                  key={mark}
                  className="text-annotation flex shrink-0 items-center gap-2.5 whitespace-nowrap text-clarus-dark/80"
                >
                  <span
                    aria-hidden="true"
                    className="h-3.5 w-3.5 shrink-0 rounded-full bg-clarus-green border border-clarus-dark/15"
                  />
                  <span>{mark}</span>
                </li>
              ))}
            </ul>
          </div>

          <HeroStickman className="hidden max-w-[440px] lg:col-span-5 lg:flex" />
        </div>
      </Container>
    </section>
  );
}
